<div class="user-profile-page" role="main" aria-label="User profile page">
    <div class="container">
        <div class="user-profile-card">

            <div class="profile-header">
                <h2 [appTranslate]="'PERSONAL_DATA'"></h2>
                <button type="button" (click)="logout()" class="btn btn-logout" aria-label="Logout">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true">
                        <path
                            d="M8.90039 7.56023C9.21039 3.96023 11.0604 2.49023 15.1104 2.49023H15.2404C19.7104 2.49023 21.5004 4.28023 21.5004 8.75023V15.2702C21.5004 19.7402 19.7104 21.5302 15.2404 21.5302H15.1104C11.0904 21.5302 9.24039 20.0802 8.91039 16.5402"
                            stroke="#072F51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15.0001 12H3.62012" stroke="#072F51" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M5.85 8.6499L2.5 11.9999L5.85 15.3499" stroke="#072F51" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span [appTranslate]="'LOGOUT'"></span>
                </button>
            </div>

            <div class="profile-section">
                <div class="form-row">
                    <div class="form-group">
                        <label class="form-group-lbl" for="profile-name"><span [appTranslate]="'NAME'"></span>
                            {{"*"}}</label>
                        <input id="profile-name" type="text" class="form-control" name="name"
                            [(ngModel)]="userModel.Name" maxlength="50" appEnglishToCyrillic
                            [placeholder]="t('ENTER_YOUR_NAME')" aria-describedby="profile-name-errors">
                        <div id="profile-name-errors" class="errors">
                            <app-error [errors]="errors" [ErrorKey]="'Name'" class="error-feedback"></app-error>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="form-group-lbl" for="profile-surname"><span [appTranslate]="'SURNAME'"></span>
                            {{"*"}}</label>
                        <input id="profile-surname" type="text" class="form-control" name="surname"
                            [(ngModel)]="userModel.Surname" maxlength="50" appEnglishToCyrillic
                            [placeholder]="t('ENTER_YOUR_SURNAME')" aria-describedby="profile-surname-errors">
                        <div id="profile-surname-errors" class="errors">
                            <app-error [errors]="errors" [ErrorKey]="'Surname'" class="error-feedback"></app-error>
                        </div>
                    </div>
                </div>
            </div>

            <div class="profile-section address">
                <h2 [appTranslate]="'ADDRESS'"></h2>
                <div class="form-row">
                    <div class="form-row">
                        <div class="form-group">
                            <label class="form-group-lbl" for="profile-street"><span [appTranslate]="'STREET'"></span>
                            </label>
                            <input id="profile-street" type="text" class="form-control" name="street"
                                [(ngModel)]="userModel.Street" maxlength="50" appEnglishToCyrillic
                                [placeholder]="t('ENTER_STREET_NAME')" aria-describedby="profile-street-errors">
                            <div id="profile-street-errors" class="errors">
                                <app-error [errors]="errors" [ErrorKey]="'Street'" class="error-feedback"></app-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-group-lbl" for="profile-street-number"><span
                                    [appTranslate]="'NUMBER'"></span> </label>
                            <input id="profile-street-number" type="text" class="form-control" name="streetNum"
                                [(ngModel)]="userModel.StreetNumber" maxlength="50" appEnglishToCyrillic
                                [placeholder]="t('ENTER_STREET_NUMBER')"
                                aria-describedby="profile-street-number-errors">
                            <div id="profile-street-number-errors" class="errors">
                                <app-error [errors]="errors" [ErrorKey]="'StreetNumber'"
                                    class="error-feedback"></app-error>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="form-group-lbl" for="profile-city"><span [appTranslate]="'CITY'"></span> </label>
                        <input id="profile-city" type="text" class="form-control" name="city"
                            [(ngModel)]="userModel.City" maxlength="50" appEnglishToCyrillic
                            [placeholder]="t('ENTER_CITY')" aria-describedby="profile-city-errors">
                        <div id="profile-city-errors" class="errors">
                            <app-error [errors]="errors" [ErrorKey]="'StreetNumber'" class="error-feedback"></app-error>
                        </div>
                    </div>
                </div>
            </div>


            <div class="profile-section noBorder">
                <h2 [appTranslate]="'CONTACT_DATA'"></h2>
                <div class="form-row">
                    <div class="form-group">
                        <label class="form-group-lbl" for="profile-email"><span [appTranslate]="'Email'"></span>
                            {{"*"}}</label>
                        <input id="profile-email" type="text" class="form-control" name="email"
                            [(ngModel)]="userModel.Email" maxlength="50" [placeholder]="t('ENTER_EMAIL_ADDRESS')"
                            aria-describedby="profile-email-errors">
                        <div id="profile-email-errors" class="errors">
                            <app-error [errors]="errors" [ErrorKey]="'Email'" class="error-feedback"></app-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-group-lbl" for="profile-phone"><span [appTranslate]="'PHONE_NUMBER'"></span>
                        </label>
                        <input id="profile-phone" type="text" class="form-control" name="phone"
                            [(ngModel)]="userModel.PhoneNumber" maxlength="50" appEnglishToCyrillic
                            [placeholder]="t('ENTER_PHONE_NUMBER')" aria-describedby="profile-phone-errors">
                        <div id="profile-phone-errors" class="errors">
                            <app-error [errors]="errors" [ErrorKey]="'PhoneNumber'" class="error-feedback"></app-error>
                        </div>
                    </div>
                </div>
            </div>

            <div class="profile-actions">
                <button type="button" class="btn btn-next" (click)="changePassword()"><span
                        [appTranslate]="'CHANGE_PASSWORD'"></span> </button>
                <button type="button" class="btn btn-primary" (click)="updateUser()" [appTranslate]="'SAVE'"
                    aria-label="Save"></button>
            </div>

            <div *ngIf="success" class="profile-success-banner">
                <div class="success-banner-icon">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11" cy="11" r="11" fill="rgba(119, 193, 30, 1)" />
                        <path d="M6 11.5L9.2 14.5L16 8" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <span class="success-banner-text" [appTranslate]="'SUCCESS'"></span>
            </div>

            <div class="errors error-messages errorReason">
                <app-error [errors]="errors" [ErrorKey]="''" class="mainErrorReason"></app-error>
            </div>
        </div>
    </div>
</div>